// Firebase disabled — no-op stub
const save = async (_data) => {
  // Firebase removed; feedback submissions are silently ignored
}

export { save }